import { createIcon } from "@chakra-ui/icons";

// Created from arrow-left.svg

export const LeftArrowIcon = createIcon({
  displayName: "Left Arrow",
  viewBox: "0 0 16 16",
  path: (
    <g>
      <path
        d="M15 8H1.6667"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 3.33398L1.3333 8.00065L6 12.6673"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="transparent"
      />
    </g>
  ),
});
